"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restrictionRuleFactory = exports.TRestrictionRuleName = void 0;
const RestrictionRuleCategoryMinMax_1 = require("./RestrictionRuleCategoryMinMax");
const RestrictionRuleItemMinMax_1 = require("./RestrictionRuleItemMinMax");
const RestrictionRuleAllowedWhen_1 = require("./RestrictionRuleAllowedWhen");
const RestrictionRuleDisallowedWhen_1 = require("./RestrictionRuleDisallowedWhen");
const RestrictionRuleCategoryMutuallyExclusive_1 = require("./RestrictionRuleCategoryMutuallyExclusive");
/**
 * Restriction Rules are the rules that limit the range, quantity and/or size
 * of items a built product can have under certain scenarios. Restriction
 * Rules are useful for determining the validity of a built product or while
 * it is being built. They can also be used for controlling the state of the
 * items during the building process.
 */
var TRestrictionRuleName;
(function (TRestrictionRuleName) {
    TRestrictionRuleName["categoryMinMax"] = "categoryMinMax";
    TRestrictionRuleName["allowedWhen"] = "allowedWhen";
    TRestrictionRuleName["itemMinMax"] = "itemMinMax";
    TRestrictionRuleName["disallowedWhen"] = "disallowedWhen";
    TRestrictionRuleName["categoryMutuallyExclusive"] = "categoryMutuallyExclusive";
})(TRestrictionRuleName = exports.TRestrictionRuleName || (exports.TRestrictionRuleName = {}));
/**
 * Given an arbitrary serialized restriction rule, returns its unserialized form.
 */
const restrictionRuleFactory = (restriction) => {
    switch (restriction.name) {
        case TRestrictionRuleName.categoryMinMax: {
            return RestrictionRuleCategoryMinMax_1.RestrictionRuleCategoryMinMax.unserialize(restriction);
        }
        case TRestrictionRuleName.itemMinMax: {
            return RestrictionRuleItemMinMax_1.RestrictionRuleItemMinMax.unserialize(restriction);
        }
        case TRestrictionRuleName.allowedWhen: {
            return RestrictionRuleAllowedWhen_1.RestrictionRuleAllowedWhen.unserialize(restriction);
        }
        case TRestrictionRuleName.disallowedWhen: {
            return RestrictionRuleDisallowedWhen_1.RestrictionRuleDisallowedWhen.unserialize(restriction);
        }
        case TRestrictionRuleName.categoryMutuallyExclusive: {
            return RestrictionRuleCategoryMutuallyExclusive_1.RestrictionRuleCategoryMutuallyExclusive.unserialize(restriction);
        }
        default:
            // just in case services has got ahead and is using a restriction rule
            // the client doesn't understand we just exclude it
            console.error(`unrecognized restriction name: ${restriction.name}`);
            return null;
    }
};
exports.restrictionRuleFactory = restrictionRuleFactory;
//# sourceMappingURL=index.js.map